<template>
	<div class="viewer">
		<div class="bg" @click="$emit('close')" />

		<div class="h-full mx-auto w-full max-w-150 overflow-auto">
			<vue-pdf-embed :source="content" />
		</div>

		<div class="close" @click="$emit('close')">
			<i class="lni lni-close"></i>
		</div>
	</div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
	name: 'PDFViewer',
	components: {
		VuePdfEmbed,
	},
	props: {
		content: String,
	},
	mounted() {
		window.addEventListener('keydown', this.onEscape)
	},
	destroyed() {
		window.removeEventListener('keydown', this.onEscape)
	},
	methods: {
		onEscape(e) {
			if (e.key === 'Escape') this.$emit('close')
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.viewer {
	width: 100%;
	height: 100%;

	.bg {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
	}

	.slide {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		overflow: auto;
		pointer-events: none;

		img {
			pointer-events: all;
			cursor: default;
			display: block;
			height: 100%;
			cursor: zoom-in;
			pointer-events: all;
		}

		&.zoomed {
			display: block;
			pointer-events: all;

			img {
				height: fit-content;
				cursor: zoom-out;
			}
		}
	}

	.btn {
		width: 25%;
		height: 100%;
		position: absolute;
		cursor: pointer;
		opacity: 0.5;
		font-size: 24px;
		color: #fff;
		display: flex;
		align-items: center;
		padding: 0 20px;

		&:hover {
			opacity: 1;
		}

		&:active i {
			transform: scale(0.9);
		}

		&.left {
			left: 0;
			top: 0;
		}

		&.right {
			right: 0;
			top: 0;
			justify-content: flex-end;
		}
	}

	.close {
		width: 100%;
		height: 100px;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
		opacity: 0.5;
		text-align: right;
		font-size: 24px;
		color: #fff;

		&:hover {
			opacity: 1;
		}

		i {
			padding: 13px;
		}
	}
}
</style>
